import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/workforce/$employeeId` — dal 04-11-2026 la scheda della persona sta in `/hr/employees/$employeeId`,
 * accanto all'elenco dei dipendenti. L'indirizzo vecchio resta come rinvio, coi suoi parametri.
 */
export const Route = createFileRoute('/_app/workforce/$employeeId')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/hr/employees/$employeeId', params: { employeeId: params.employeeId }, search: search as never, replace: true });
  },
});
